export enum LoanActionType {
    Modify = 0,
    AddSubNote = 1,
    Close = 2,
    Lost = 3,
    ReleaseHoldback = 4,
    Draw = 5,
    PropertyRepayment = 6,
    LoanRepayment = 7,
    Extend = 8,
    WatchList = 9,
    RentalDscr = 10,
    Convert = 11,
    Delete = 12,
    Restore = 13,
    RevertToApproved = 14,
    Insurance = 15,
    History = 16,
    ChangeLoanType = 17,
}
